import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography, Button, CircularProgress } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import I18n from '../../localization';
import { useStyles } from './IQAirSerialNumberStyles';
import {IQ_AIR_MODEL} from '../../utils/constant'


const IQAirSerialNumber = (props) => {
    const classes = useStyles();
    const [serialNumber, setSerialNumber] = useState('');
    const [errormessage, setErrormessage] = useState(false);
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isValid = serialNumber.trim().length === 15 && /^\d{15}$/.test(serialNumber);

    useEffect(() => {
        const handleResize = () => {
            setIsKeyboardOpen(window.innerHeight <= window.outerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const value = event.target.value.replace(/\s/g, '').replace(/[^0-9]/g, '');
        setSerialNumber(value.substring(0, 15));

        if (value.length === 0) {
            setErrormessage(false);
        } else if (!/^\d+$/.test(value)) {
            setErrormessage(true);
        } else if (value.length === 15) {
            setErrormessage(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && isValid) submitSerialNumber();
    };


    const submitSerialNumber = () => {
        if (!isValid) {
            setErrormessage(true);
            return;
        }
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            props.onConfirm(serialNumber);
        }, 2000);
    };

    const handleCancel = () => {
        props.closePopUp();
    };

    return (
        <Box className={`${classes.popupRoot} ${isKeyboardOpen ? classes.popupWithKeyboard : classes.popupWithoutKeyboard}`}>
            <Box className={classes.header} style={{ justifyContent: 'flex-start' }}>
                <Typography className={`${classes.renamepopupheading} ${classes.customHeader}`}>
                    {I18n.t('mobile.AirDeviceProvisioning.enterSerialNumber')}
                </Typography>
            </Box>

            <Divider className={classes.dividerBorderColor} />

            <Typography className={classes.descriptionText}>
                {props.iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID ? I18n.t('mobile.AirDeviceProvisioning.serialNumberLimitHeading'):I18n.t('mobile.AirDeviceProvisioning.serialNumberLimitHeadingSecondary')}
            </Typography>

            <Box className={classes.renamewifitextfield}>
                <TextField
                    type="tel"
                    id="serialNumberInput"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    value={serialNumber}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setIsKeyboardOpen(true)}
                    onBlur={() => setIsKeyboardOpen(false)}
                    className={`${classes.root} ${classes.inputRootCustom}`}
                />
            </Box>

            <Box className={classes.actionGroup}>
                <Button
                    onClick={handleCancel}
                    className={classes.cancelButton}
                    variant="outlined"
                >
                    {I18n.t('mobile.common.cancelBtn')}
                </Button>

                <Button
                    onClick={submitSerialNumber}
                    className={classes.confirmButton}
                    disabled={!isValid}
                    variant="contained"
                >
                    {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (I18n.t('mobile.common.confirmBtn'))
                    }
                </Button>
            </Box>
        </Box>
    );
};

export default IQAirSerialNumber;